import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
export const LabelContainer = styled.label`
  font-family: var(--font-workSans);
  font-size: 18px;
  line-height: 23px;
  align-self: flex-start;
`;
export const InputContainer = styled.input`
  background-color: rgba(255, 218, 109, 0.2);
  border: none;
  height: 50px;
  border-radius: 10px;
  color: white;
  padding-left: 1rem;
  font-size: 20px;

  &::placeholder {
    font-size: 16px;
    font-family: var(--font-raleway);
  }
`;

export const ErrorMessage = styled.span`
  color: red;
  display: flex;
  align-items: center;
  justify-content: center;
`;
